import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tw-grid tw-grid-cols-12 tw-gap-4" };
const _hoisted_2 = {
    key: 0,
    class: "tw-space-y-6 mt-4"
};
const _hoisted_3 = { class: "tw-space-y-3" };
const _hoisted_4 = {
    key: 0,
    class: "tw-w-full"
};
const _hoisted_5 = { class: "tw-w-full tw-my-2 tw-flex tw-justify-between" };
const _hoisted_6 = { class: "tw-flex tw-gap-2" };
const _hoisted_7 = ["src"];
const _hoisted_8 = { class: "tw-flex tw-gap-2" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "single-slide" };
const _hoisted_12 = { class: "box tw-mb-4" };
const _hoisted_13 = { class: "img-box" };
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = {
    key: 1,
    class: "tw-w-full tw-my-5"
};
const _hoisted_16 = { class: "tw-flex md:tw-hidden tw-items-center sm:tw-gap-3 tw-gap-2" };
const _hoisted_17 = { class: "" };
const _hoisted_18 = ["src"];
const _hoisted_19 = { class: "" };
const _hoisted_20 = ["src"];
const _hoisted_21 = { class: "tw-flex tw-gap-3" };
const _hoisted_22 = {
    key: 0,
    class: "md:tw-relative md:tw-w-[70%] tw-max-h-[calc(100vh-180px)] tw-h-[calc(100vh-180px)] tw-w-[90%] tw-absolute sm:tw-right-unset tw-right-0 sm:tw-left-unset tw-left-0 tw-mx-auto sm:tw-top-0 tw-top-[0px]"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["src", "alt"];
const _hoisted_26 = {
    key: 0,
    class: "md:tw-block tw-hidden tw-col-span-3"
};
import { ref, onMounted, onUnmounted, watch, } from "vue";
import Const from "@/const";
import { useRouter } from "vue-router";
import { useLogo } from "@/hooks/useLogo";
import { useSidebar } from "@/stores/sidebar";
import { usePopupStore } from "@/stores/popup";
import GamesByProviders from "./GamesByProviders.vue";
import SideBarProviders from "@/components/Casino/SideBarProviders.vue";
// Props
export default /*@__PURE__*/ _defineComponent({
    __name: 'CasinoComponentForAll',
    props: {
        games: {},
        casinoSideBarCategories: {},
        gameCategories: {},
        selectedCategory: {},
        isLoading: { type: Boolean }
    },
    emits: ["viewGames"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const scrollContainer = ref(null);
        const gameUrl = ref(null);
        const router = useRouter();
        const logo = useLogo();
        const { handleCloseSidebar } = useSidebar();
        const activeAccordion = ref(null);
        // Search query ref
        const searchQuery = ref("");
        // Function to check if a category or game is selected
        const isSelected = (href) => router.currentRoute.value.path === href;
        const filteredGames = (gameCat) => {
            return props.games.filter((game) => game.gamebank === gameCat.gameType &&
                game.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
        };
        const showProviders = ref(false);
        const toggleProviders = () => {
            showProviders.value = !showProviders.value;
        };
        const activeCategoryId = ref(null);
        const handleGameClick = (game) => {
            if (!localStorage.getItem("user")) {
                usePopupStore().showPopup("login");
                return;
            }
            const url = `https://azurecoinz.com/game/${game.name}?api_exit=/`;
            gameUrl.value = url;
        };
        const closeGame = () => (gameUrl.value = null);
        const toggleView = (categoryId) => {
            emit("viewGames", { title: "All", id: null });
            router.replace({ path: "/casino/all" });
            activeCategoryId.value =
                activeCategoryId.value === categoryId ? null : categoryId;
        };
        const config = ref({
            itemsToShow: 16,
            autoplay: 3000,
            infinite: true,
            gap: 10,
        });
        const screenWidth = ref(window.innerWidth);
        watch(screenWidth, (newWidth) => {
            if (newWidth < 640) {
                config.value.itemsToShow = 3;
            }
            else {
                config.value.itemsToShow = 6;
            }
        });
        // Update screenWidth on window resize
        onMounted(() => {
            const handleResize = () => {
                screenWidth.value = window.innerWidth;
            };
            window.addEventListener("resize", handleResize);
            onUnmounted(() => {
                window.removeEventListener("resize", handleResize);
            });
        });
        return (_ctx, _cache) => {
            const _component_Card = _resolveComponent("Card");
            const _component_CardContent = _resolveComponent("CardContent");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass([gameUrl.value ? 'tw-col-span-12' : 'md:tw-col-span-9 tw-col-span-12', ""])
                }, [
                    (_ctx.selectedCategory && _ctx.selectedCategory.title === 'All')
                        ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.casinoSideBarCategories, (gameCat) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: gameCat.id,
                                            class: "tw-border-none tw-p-0"
                                        }, [
                                            (!activeCategoryId.value || activeCategoryId.value === gameCat.id)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tw-w-full tw-p-0 tw-mb-0" }, [
                                                        _createElementVNode("div", { class: "tw-transition-all tw-duration-300 tw-ease-in-out tw-border-l-2 tw-cursor-pointer tw-text-[#738499] tw-group tw-border-l-transparent" })
                                                    ], -1)),
                                                    (activeCategoryId.value === gameCat.id)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                            _createElementVNode("div", _hoisted_5, [
                                                                _createElementVNode("div", _hoisted_6, [
                                                                    _createElementVNode("img", {
                                                                        src: `${_unref(Const).URL}/img/sq-arrow-left.svg`,
                                                                        alt: "Previous",
                                                                        class: "tw-w-[44px] tw-h-[45px]"
                                                                    }, null, 8, _hoisted_7)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_8, [
                                                                    _createElementVNode("img", {
                                                                        src: `${_unref(Const).URL}/img/sq-arrow-right.svg`,
                                                                        alt: "Next",
                                                                        class: "tw-w-[44px] tw-h-[45px]"
                                                                    }, null, 8, _hoisted_9)
                                                                ])
                                                            ]),
                                                            _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-w-full tw-bg-transparent" }, {
                                                                default: _withCtx(() => [
                                                                    (filteredGames(gameCat).length)
                                                                        ? (_openBlock(), _createElementBlock("div", {
                                                                            key: 0,
                                                                            ref_for: true,
                                                                            ref_key: "scrollContainer",
                                                                            ref: scrollContainer
                                                                        }, [
                                                                            _createElementVNode("div", _hoisted_10, [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGames(gameCat).slice(0, 20), (game) => {
                                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                                        key: game.id,
                                                                                        class: "col-25"
                                                                                    }, [
                                                                                        _createElementVNode("div", _hoisted_11, [
                                                                                            _createElementVNode("div", _hoisted_12, [
                                                                                                _createElementVNode("div", _hoisted_13, [
                                                                                                    _createElementVNode("img", {
                                                                                                        src: `https://azurecoinz.com/frontend/Default/ico/${game.name}.jpg`,
                                                                                                        alt: game.name,
                                                                                                        class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                                                                    }, null, 8, _hoisted_14)
                                                                                                ])
                                                                                            ])
                                                                                        ])
                                                                                    ]));
                                                                                }), 128))
                                                                            ])
                                                                        ], 512))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                            _createElementVNode("div", {
                                                                class: _normalizeClass([gameUrl.value ? 'min-[992px]:tw-w-[70%] tw-w-full' : '', "tw-block input-categories"])
                                                            }, [
                                                                _createElementVNode("div", _hoisted_16, [
                                                                    _createElementVNode("div", _hoisted_17, [
                                                                        _createElementVNode("img", {
                                                                            src: `${_unref(Const).URL}/img/sq-arrow-left.svg`,
                                                                            alt: "Previous",
                                                                            class: "tw-w-[44px] tw-h-[45px]"
                                                                        }, null, 8, _hoisted_18)
                                                                    ]),
                                                                    _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1)),
                                                                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "md:tw-hidden tw-block tw-w-full" }, [
                                                                        _createElementVNode("a", { href: "casino/all" }, [
                                                                            _createElementVNode("img", {
                                                                                src: `https://azurecoinz.com/frontend/Default/img/providers/allproviders.png`,
                                                                                alt: "all providers"
                                                                            })
                                                                        ])
                                                                    ], -1)),
                                                                    _createElementVNode("div", _hoisted_19, [
                                                                        _createElementVNode("img", {
                                                                            src: `${_unref(Const).URL}/img/sq-arrow-right.svg`,
                                                                            alt: "Next",
                                                                            class: "tw-w-[44px] tw-h-[45px]"
                                                                        }, null, 8, _hoisted_20)
                                                                    ])
                                                                ])
                                                            ], 2),
                                                            _createElementVNode("div", _hoisted_21, [
                                                                (gameUrl.value)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                                        _createElementVNode("button", {
                                                                            class: "tw-absolute tw-top-2 tw-right-2 tw-bg-red-500 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-text-sm tw-font-bold",
                                                                            onClick: closeGame
                                                                        }, " Close "),
                                                                        _createElementVNode("iframe", {
                                                                            src: gameUrl.value,
                                                                            frameborder: "0",
                                                                            class: "tw-w-full tw-h-full"
                                                                        }, null, 8, _hoisted_23)
                                                                    ]))
                                                                    : _createCommentVNode("", true),
                                                                _createElementVNode("div", {
                                                                    class: _normalizeClass(gameUrl.value ? 'md:tw-w-[30%] tw-w-full' : 'tw-w-full')
                                                                }, [
                                                                    _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-col-span-full tw-xl:col-span-4 tw-w-full tw-bg-transparent" }, {
                                                                        default: _withCtx(() => [
                                                                            (_ctx.games.length)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 0,
                                                                                    ref_for: true,
                                                                                    ref_key: "scrollContainer",
                                                                                    ref: scrollContainer,
                                                                                    class: _normalizeClass([
                                                                                        gameUrl.value
                                                                                            ? 'tw-max-h-[calc(100vh-214px)]'
                                                                                            : 'tw-max-h-[calc(100vh-180px)]',
                                                                                        "tw-overflow-auto"
                                                                                    ])
                                                                                }, [
                                                                                    _createVNode(_component_CardContent, {
                                                                                        class: _normalizeClass(gameUrl.value
                                                                                            ? 'scroller tw-grid tw-grid-cols-3  md:tw-grid-cols-2 lg:tw-grid-cols-2 tw-gap-4'
                                                                                            : 'scroller tw-grid tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-4 tw-bg-[#140736]')
                                                                                    }, {
                                                                                        default: _withCtx(() => [
                                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
                                                                                                return (_openBlock(), _createElementBlock("div", {
                                                                                                    key: game.id
                                                                                                }, [
                                                                                                    _createElementVNode("div", {
                                                                                                        class: "tw-flex tw-items-center tw-gap-4 2xl:tw-gap-3 tw-rounded tw-cursor-pointer tw-w-full tw-h-full",
                                                                                                        onClick: ($event) => (handleGameClick(game))
                                                                                                    }, [
                                                                                                        _createElementVNode("img", {
                                                                                                            src: `https://azurecoinz.com/frontend/Default/ico/${game.name}.jpg`,
                                                                                                            alt: game.name,
                                                                                                            class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                                                                        }, null, 8, _hoisted_25)
                                                                                                    ], 8, _hoisted_24)
                                                                                                ]));
                                                                                            }), 128))
                                                                                        ]),
                                                                                        _: 1
                                                                                    }, 8, ["class"]),
                                                                                    (_ctx.isLoading)
                                                                                        ? (_openBlock(), _createBlock(_component_CardContent, {
                                                                                            key: 0,
                                                                                            class: _normalizeClass(gameUrl.value
                                                                                                ? 'tw-mt-6 tw-grid tw-grid-cols-3 sm:tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4'
                                                                                                : 'tw-grid tw-grid-cols-3 md:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-6 tw-gap-5 tw-mt-6')
                                                                                        }, {
                                                                                            default: _withCtx(() => [
                                                                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                                                                                                    return _createElementVNode("div", {
                                                                                                        key: 'skeleton-' + index,
                                                                                                        class: "tw-flex tw-items-center tw-gap-4 tw-rounded tw-animate-pulse"
                                                                                                    }, _cache[2] || (_cache[2] = [
                                                                                                        _createElementVNode("div", { class: "tw-bg-gray-300 tw-rounded-md md:tw-h-32 tw-h-[70px] tw-w-full" }, null, -1)
                                                                                                    ]));
                                                                                                }), 64))
                                                                                            ]),
                                                                                            _: 1
                                                                                        }, 8, ["class"]))
                                                                                        : _createCommentVNode("", true)
                                                                                ], 2))
                                                                                : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ], 2)
                                                            ])
                                                        ]))
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]))
                        : (_openBlock(), _createBlock(GamesByProviders, {
                            key: 1,
                            games: _ctx.games,
                            selectedCategory: _ctx.selectedCategory,
                            isLoading: _ctx.isLoading
                        }, null, 8, ["games", "selectedCategory", "isLoading"]))
                ], 2),
                (!gameUrl.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(SideBarProviders, {
                            games: _ctx.games,
                            selectedCategory: _ctx.selectedCategory,
                            isLoading: _ctx.isLoading
                        }, null, 8, ["games", "selectedCategory", "isLoading"])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
